import React from 'react'
import SignIn from '../components/SignIn/SignIn'

function SignupPage() {
    return (
        <div>
            <SignIn />
        </div>
    )
}

export default SignupPage
